import React from "react";
import CreateMovementForm from "../CreateMovementForm";

export default function OfficeToAndFroFormSection({ masterData, onSuccess }) {
  return (
    <div
      id="otf-add"
      className="user-builder-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Movement entry</h3>
        <p className="user-builder-panel__hint">
          Create a new movement entry for staff or volunteers.
        </p>
      </div>
      <CreateMovementForm masterData={masterData} onSuccess={onSuccess} />
    </div>
  );
}
